import React from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { my_routes } from "../../router/all_routes";

const Error404 = () => {
  const routes = my_routes;

  return (
    <div>
      <div className="row justify-content-center">
        <div className="col-xxl-6 col-xl-7 col-md-6">
          <div className="d-flex flex-column align-items-center justify-content-between vh-100">
            <div className="text-center p-4 d-flex flex-row align-items-center justify-content-center gap-2">
              <ImageWithBasePath
                src="assets/img/logo_uie.png"
                alt="img"
                className="img-fluid"
                height={100}
                width={100}
              />
              <span className="text-dark ms-2 fw-bold fs-40">
                Université - UIE
              </span>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center mb-4">
              <div className="mb-4">
                <ImageWithBasePath
                  src="assets/img/authentication/error-404.svg"
                  className="error-img img-fluid"
                  alt="Img"
                />
              </div>
              <h3 className="h2 mb-3">Oups, quelque chose s'est mal passé</h3>
              <p className="text-center">
                Erreur 404 Page non trouvée. Désolé la page que vous cherchez
                n'existe pas ou a été déplacée
              </p>
              <Link to={routes.home}>
                <button className="btn btn-primary d-flex align-items-center mb-2">
                  <i className="ti ti-home me-2" />
                  Retour à l'accueil
                </button>
              </Link>
            </div>
            <div className="text-center p-4">
              <p>Copyright © 2026 - Université - UIE</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error404;
